import { track } from '@mobi/account/Utils/analytics'
import { MedicareCardColor } from '@mobi/api-types/src/account/signup'
import { capitalize } from '@mobi/utils/string'
import { IdentityVerificationMethod } from '../typings/types'

export type VerificationAnalyticsKey = 'verification_process'

export type VerificationSuccessStep = 'Verified Address' | 'Verified Identification'

export type VerificationProcessEvent = {
  interaction_type: 'Select Option' | 'Contact Us' | 'Success'
  location: string | undefined
  medicareColour: 'Green' | 'Yellow' | 'Blue' | undefined
  message: string | undefined
  optionSelected: string | undefined
  previousStep: VerificationSuccessStep | undefined
  repeatAttempt: string | undefined
  verifyResult: 'Success' | 'Fail' | undefined
}

const defaultVerificationProcessValues: Omit<VerificationProcessEvent, 'interaction_type'> = {
  location: undefined,
  medicareColour: undefined,
  message: undefined,
  optionSelected: undefined,
  previousStep: undefined,
  repeatAttempt: undefined,
  verifyResult: undefined,
}

export const verificationProcessTracker = (event: VerificationProcessEvent) =>
  track('verification_process', event)

export const trackVerificationSelectOption = (
  optionSelected: IdentityVerificationMethod | undefined,
  repeatAttempt: number
) =>
  verificationProcessTracker({
    interaction_type: 'Select Option',
    ...defaultVerificationProcessValues,
    optionSelected: capitalize(optionSelected ?? 'none'),
    repeatAttempt: repeatAttempt.toString(),
  })

export const trackVerificationContactUs = () =>
  verificationProcessTracker({
    interaction_type: 'Contact Us',
    ...defaultVerificationProcessValues,
  })

export const trackVerificationSuccess = (
  previousStep: VerificationSuccessStep,
  optionSelected?: IdentityVerificationMethod,
  medicareColour?: MedicareCardColor | null
) =>
  verificationProcessTracker({
    interaction_type: 'Success',
    ...defaultVerificationProcessValues,
    optionSelected: optionSelected ? capitalize(optionSelected) : undefined,
    medicareColour: medicareColour ?? undefined,
    previousStep,
  })
